module.exports = __webpack_public_path__ + "static/media/Woohoo.bb4a823e.wav";